<template>
  <div class="clickable" @click="onNodeAdd" v-if="addNewNodeAllowed">
    <i class="mdi mdi-plus-circle-outline"></i>
    Agregar condición
  </div>
</template>

<script>
export default {
  name: 'NodeAddBtn',
  props: {
    nodes: Array,
    maxConditions: Number
  },
  computed: {
    addNewNodeAllowed () {
      return this.maxConditions === null || this.nodes.filter(n => n?.type === 'condition').length < this.maxConditions
    }
  },
  methods: {
    onNodeAdd () {
      if (this.addNewNodeAllowed) {
        this.$emit('node-add', { nodes: this.nodes })
      } else {
        console.log('Máximo de condiciones alcanzado')
      }
    }
  }
}
</script>
